import type { ChakraProps } from '@chakra-ui/react';
import { Input, InputGroup, InputLeftElement } from '@chakra-ui/react';
import { getAssetUrl } from '@cronos-app/chakra';
import { MaskIcon } from '@ui/components/MaskIcon';
import { useTranslations } from 'next-intl';

import { useTokenSelectModal } from '../useTokenSelectModal';

export const SearchInput = (props: ChakraProps) => {
  const t = useTranslations();
  return (
    <InputGroup variant="search" {...props}>
      <InputLeftElement pointerEvents="none" color="gray.300" fontSize="1.2em">
        <MaskIcon
          icon={`url(${getAssetUrl('/masks/search.svg')})`}
          boxSize="24px"
          bg="brand.gray-scale-light-grey"
        />
      </InputLeftElement>
      <Input
        placeholder={t('card.search by token name or paste address')}
        onChange={(e) => {
          useTokenSelectModal.setState({
            search: e.target.value,
          });
        }}
      />
    </InputGroup>
  );
};
